var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import walletClaimsData from "../data/urls.json";
import { Box, CircularProgress, Link as HyperLink, Typography, } from "@mui/material";
import { useWallet, useAnchorWallet } from "../contexts/WalletContext";
import { PublicKey, SystemProgram, Transaction, } from "@solana/web3.js";
import { AccountLayout, Token, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { notify } from "../utils/notifications";
import BN from "bn.js";
import bs58 from "bs58";
import * as anchor from "@project-serum/anchor";
import { useConnection } from "../contexts/ConnectionContext";
import { GUMDROP_DISTRIBUTOR_ID, SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID, } from "../utils/ids";
import { getATA } from "../utils/accounts";
import { MerkleTree } from "../utils/merkleTree";
import { explorerLinkFor, sendSignedTransaction } from "../utils/transactions";
import { useWalletModal } from "../contexts/WalletContext";
import { claimStyles as styles } from "./Claim.styles";
export var chunk = function (arr, len) {
    var chunks = [];
    var n = arr.length;
    var i = 0;
    while (i < n) {
        chunks.push(arr.slice(i, (i += len)));
    }
    return chunks;
};
var walletKeyOrPda = function (walletKey, handle, pin, seed) { return __awaiter(void 0, void 0, Promise, function () {
    var key, seeds, _a, claimantPda;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(pin === null)) return [3 /*break*/, 1];
                try {
                    key = new PublicKey(handle);
                    if (!key.equals(walletKey)) {
                        throw new Error("Claimant wallet handle does not match connected wallet");
                    }
                    return [2 /*return*/, [key, []]];
                }
                catch (err) {
                    throw new Error("Invalid claimant wallet handle ".concat(err));
                }
                return [3 /*break*/, 3];
            case 1:
                seeds = [
                    seed.toBuffer(),
                    Buffer.from(handle),
                    Buffer.from(pin.toArray("le", 4)),
                ];
                return [4 /*yield*/, PublicKey.findProgramAddress(__spreadArray(__spreadArray([seeds[0]], __read(chunk(seeds[1], 32)), false), [seeds[2]], false), GUMDROP_DISTRIBUTOR_ID)];
            case 2:
                _a = __read.apply(void 0, [_b.sent(), 1]), claimantPda = _a[0];
                return [2 /*return*/, [claimantPda, seeds]];
            case 3: return [2 /*return*/];
        }
    });
}); };
var buildMintClaim = function (program, walletKey, distributorKey, distributorInfo, tokenAcc, proof, handle, amount, index, pin) { return __awaiter(void 0, void 0, Promise, function () {
    var tokenAccKey, distTokenAccount, tokenAccountInfo, mint, _a, secret, pdaSeeds, leaf, matches, _b, claimStatus, cbump, claimStatusAccount, setup, walletTokenKey, temporalSigner, claimAirdrop;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                try {
                    tokenAccKey = new PublicKey(tokenAcc);
                }
                catch (err) {
                    throw new Error("Invalid tokenAcc key ".concat(err));
                }
                return [4 /*yield*/, program.provider.connection.getAccountInfo(tokenAccKey)];
            case 1:
                distTokenAccount = _c.sent();
                if (distTokenAccount === null) {
                    throw new Error("Could not fetch distributor token account");
                }
                tokenAccountInfo = AccountLayout.decode(distTokenAccount.data);
                mint = new PublicKey(tokenAccountInfo.mint);
                return [4 /*yield*/, walletKeyOrPda(walletKey, handle, pin, mint)];
            case 2:
                _a = __read.apply(void 0, [_c.sent(), 2]), secret = _a[0], pdaSeeds = _a[1];
                leaf = Buffer.from(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(new BN(index).toArray("le", 8)), false), __read(secret.toBuffer()), false), __read(mint.toBuffer()), false), __read(new BN(amount.toLocaleString("fullwide", { useGrouping: false })).toArray("le", 8)), false));
                matches = MerkleTree.verifyClaim(leaf, proof, Buffer.from(distributorInfo.root));
                if (!matches) {
                    throw new Error("Merkle proof does not match");
                }
                return [4 /*yield*/, PublicKey.findProgramAddress([
                        Buffer.from("ClaimStatus"),
                        Buffer.from(new BN(index).toArray("le", 8)),
                        distributorKey.toBuffer(),
                    ], GUMDROP_DISTRIBUTOR_ID)];
            case 3:
                _b = __read.apply(void 0, [_c.sent(), 2]), claimStatus = _b[0], cbump = _b[1];
                return [4 /*yield*/, program.provider.connection.getAccountInfo(claimStatus)];
            case 4:
                claimStatusAccount = _c.sent();
                if (claimStatusAccount !== null) {
                    throw new Error("ALREADY_CLAIMED");
                }
                setup = [];
                return [4 /*yield*/, getATA(walletKey, mint)];
            case 5:
                walletTokenKey = _c.sent();
                return [4 /*yield*/, program.provider.connection.getAccountInfo(walletTokenKey)];
            case 6:
                if ((_c.sent()) === null) {
                    setup.push(Token.createAssociatedTokenAccountInstruction(SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID, TOKEN_PROGRAM_ID, mint, walletTokenKey, walletKey, walletKey));
                }
                temporalSigner = distributorInfo.temporal.equals(PublicKey.default) ||
                    secret.equals(walletKey)
                    ? walletKey
                    : distributorInfo.temporal;
                return [4 /*yield*/, program.instruction.claim(cbump, new BN(index), new BN(amount.toLocaleString("fullwide", { useGrouping: false })), secret, proof, {
                        accounts: {
                            distributor: distributorKey,
                            claimStatus: claimStatus,
                            from: tokenAccKey,
                            to: walletTokenKey,
                            temporal: temporalSigner,
                            payer: walletKey,
                            systemProgram: SystemProgram.programId,
                            tokenProgram: TOKEN_PROGRAM_ID,
                        },
                    })];
            case 7:
                claimAirdrop = _c.sent();
                return [2 /*return*/, [{ setup: setup, claim: [claimAirdrop] }, pdaSeeds, []]];
        }
    });
}); };
var fetchDistributor = function (program, distributorStr) { return __awaiter(void 0, void 0, void 0, function () {
    var key, info;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                try {
                    key = new PublicKey(distributorStr);
                }
                catch (err) {
                    throw new Error("Invalid distributor key ".concat(err));
                }
                return [4 /*yield*/, program.account.merkleDistributor.fetch(key)];
            case 1:
                info = _a.sent();
                return [2 /*return*/, [key, info]];
        }
    });
}); };
var checkAlreadyClaimed = function (program, distributorStr, indexStr) { return __awaiter(void 0, void 0, Promise, function () {
    var distributorKey, index, _a, claimStatus, claimStatusAccount, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                distributorKey = new PublicKey(distributorStr);
                index = Number(indexStr);
                return [4 /*yield*/, PublicKey.findProgramAddress([
                        Buffer.from("ClaimStatus"),
                        Buffer.from(new BN(index).toArray("le", 8)),
                        distributorKey.toBuffer(),
                    ], GUMDROP_DISTRIBUTOR_ID)];
            case 1:
                _a = __read.apply(void 0, [_c.sent(), 1]), claimStatus = _a[0];
                return [4 /*yield*/, program.provider.connection.getAccountInfo(claimStatus)];
            case 2:
                claimStatusAccount = _c.sent();
                return [2 /*return*/, claimStatusAccount !== null];
            case 3:
                _b = _c.sent();
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
var formatAmount = function (rawAmount) {
    var amount = rawAmount / 1000000;
    return amount.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};
export var Claim = function () {
    var connection = useConnection();
    var wallet = useAnchorWallet();
    var connected = useWallet().connected;
    var setWalletModalVisible = useWalletModal().setVisible;
    var _a = __read(React.useState(null), 2), program = _a[0], setProgram = _a[1];
    var _b = __read(React.useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(React.useState(false), 2), checkingEligibility = _c[0], setCheckingEligibility = _c[1];
    var _d = __read(React.useState(null), 2), claimData = _d[0], setClaimData = _d[1];
    var _e = __read(React.useState(false), 2), alreadyClaimed = _e[0], setAlreadyClaimed = _e[1];
    var _f = __read(React.useState(false), 2), claimSuccess = _f[0], setClaimSuccess = _f[1];
    var _g = __read(React.useState(null), 2), txLink = _g[0], setTxLink = _g[1];
    var _h = __read(React.useState(""), 2), distributor = _h[0], setDistributor = _h[1];
    var _j = __read(React.useState(""), 2), tokenAcc = _j[0], setTokenAcc = _j[1];
    var _k = __read(React.useState(""), 2), handle = _k[0], setHandle = _k[1];
    var _l = __read(React.useState(""), 2), amountStr = _l[0], setAmountStr = _l[1];
    var _m = __read(React.useState(""), 2), indexStr = _m[0], setIndexStr = _m[1];
    var _o = __read(React.useState(""), 2), proofStr = _o[0], setProofStr = _o[1];
    React.useEffect(function () {
        if (!wallet) {
            setProgram(null);
            return;
        }
        var wrap = function () { return __awaiter(void 0, void 0, void 0, function () {
            var provider, gumdropIdl, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        provider = new anchor.Provider(connection, wallet, {
                            preflightCommitment: "recent",
                        });
                        return [4 /*yield*/, anchor.Program.fetchIdl(GUMDROP_DISTRIBUTOR_ID, provider)];
                    case 1:
                        gumdropIdl = _a.sent();
                        if (!gumdropIdl)
                            throw new Error("Failed to fetch gumdrop IDL");
                        setProgram({
                            gumdrop: new anchor.Program(gumdropIdl, GUMDROP_DISTRIBUTOR_ID, provider),
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error("Failed to fetch IDL", err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        wrap();
    }, [wallet, connection]);
    React.useEffect(function () {
        if (!(wallet === null || wallet === void 0 ? void 0 : wallet.publicKey) || !program) {
            setClaimData(null);
            setAlreadyClaimed(false);
            return;
        }
        var checkEligibility = function () { return __awaiter(void 0, void 0, void 0, function () {
            var walletAddress, foundClaim, url, urlParams, claimed, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCheckingEligibility(true);
                        walletAddress = wallet.publicKey.toString();
                        foundClaim = walletClaimsData.find(function (claim) { return claim.handle === walletAddress; });
                        if (!(foundClaim && foundClaim.url)) return [3 /*break*/, 5];
                        setClaimData(foundClaim);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        url = new URL(foundClaim.url);
                        urlParams = new URLSearchParams(url.search);
                        setDistributor(urlParams.get("distributor") || "");
                        setHandle(foundClaim.handle);
                        setAmountStr(foundClaim.amount.toString());
                        setIndexStr(urlParams.get("index") || "");
                        setTokenAcc(urlParams.get("tokenAcc") || "");
                        setProofStr(urlParams.get("proof") || "");
                        return [4 /*yield*/, checkAlreadyClaimed(program.gumdrop, urlParams.get("distributor") || "", urlParams.get("index") || "")];
                    case 2:
                        claimed = _a.sent();
                        setAlreadyClaimed(claimed);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.error("Error parsing claim URL:", err_2);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        setClaimData(null);
                        _a.label = 6;
                    case 6:
                        setCheckingEligibility(false);
                        return [2 /*return*/];
                }
            });
        }); };
        checkEligibility();
    }, [wallet, program]);
    var handleClaim = function () { return __awaiter(void 0, void 0, void 0, function () {
        var index, amount, _a, distributorKey, distributorInfo, proof, _b, instructions, extraSigners_1, signersOf, partialSignExtra, _c, recentBlockhash, lastValidBlockHeight, setupTx, setupInstrs, setupSigners, claimTx, claimInstrs, claimSigners, transaction, fullySigned, _d, lastTxId, idx, tx, result, err_3, msg;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!wallet || !program) {
                        notify({
                            message: "Error",
                            description: "Wallet not connected",
                        });
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 13, 14, 15]);
                    index = Number(indexStr);
                    amount = Number(amountStr);
                    if (isNaN(amount) || isNaN(index)) {
                        throw new Error("Invalid claim parameters");
                    }
                    return [4 /*yield*/, fetchDistributor(program.gumdrop, distributor)];
                case 2:
                    _a = __read.apply(void 0, [_e.sent(), 2]), distributorKey = _a[0], distributorInfo = _a[1];
                    proof = proofStr === ""
                        ? []
                        : proofStr.split(",").map(function (b) {
                            var decoded = bs58.decode(b);
                            var ret = Buffer.from(decoded.buffer, decoded.byteOffset, decoded.byteLength);
                            if (ret.length !== 32)
                                throw new Error("Invalid proof hash length");
                            return ret;
                        });
                    return [4 /*yield*/, buildMintClaim(program.gumdrop, wallet.publicKey, distributorKey, distributorInfo, tokenAcc, proof, handle, amount, index, null)];
                case 3:
                    _b = __read.apply(void 0, [_e.sent(), 3]), instructions = _b[0], extraSigners_1 = _b[2];
                    signersOf = function (instrs) {
                        var e_1, _a, e_2, _b;
                        var signers = new Set();
                        try {
                            for (var instrs_1 = __values(instrs), instrs_1_1 = instrs_1.next(); !instrs_1_1.done; instrs_1_1 = instrs_1.next()) {
                                var instr = instrs_1_1.value;
                                try {
                                    for (var _c = (e_2 = void 0, __values(instr.keys)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                        var key = _d.value;
                                        if (key.isSigner)
                                            signers.add(key.pubkey);
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (instrs_1_1 && !instrs_1_1.done && (_a = instrs_1.return)) _a.call(instrs_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return __spreadArray([], __read(signers), false);
                    };
                    partialSignExtra = function (tx, expected) {
                        var matching = extraSigners_1.filter(function (kp) {
                            return expected.find(function (p) { return p.equals(kp.publicKey); });
                        });
                        if (matching.length > 0) {
                            tx.partialSign.apply(tx, __spreadArray([], __read(matching), false));
                        }
                    };
                    return [4 /*yield*/, connection.getLatestBlockhash("confirmed")];
                case 4:
                    _c = _e.sent(), recentBlockhash = _c.blockhash, lastValidBlockHeight = _c.lastValidBlockHeight;
                    setupTx = null;
                    if (instructions.setup !== null && instructions.setup.length !== 0) {
                        setupTx = new Transaction({
                            feePayer: wallet.publicKey,
                            recentBlockhash: recentBlockhash,
                        });
                        setupInstrs = instructions.setup;
                        setupSigners = signersOf(setupInstrs);
                        setupTx.add.apply(setupTx, __spreadArray([], __read(setupInstrs), false));
                        setupTx.setSigners.apply(setupTx, __spreadArray([], __read(setupSigners), false));
                        partialSignExtra(setupTx, setupSigners);
                    }
                    claimTx = new Transaction({
                        feePayer: wallet.publicKey,
                        recentBlockhash: recentBlockhash,
                    });
                    claimInstrs = instructions.claim;
                    claimSigners = signersOf(claimInstrs);
                    claimTx.add.apply(claimTx, __spreadArray([], __read(claimInstrs), false));
                    claimTx.setSigners.apply(claimTx, __spreadArray([], __read(claimSigners), false));
                    partialSignExtra(claimTx, claimSigners);
                    transaction = {
                        setup: setupTx,
                        claim: claimTx,
                    };
                    fullySigned = void 0;
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, wallet.signAllTransactions(transaction.setup === null
                            ? [transaction.claim]
                            : [transaction.setup, transaction.claim])];
                case 6:
                    fullySigned = _e.sent();
                    return [3 /*break*/, 8];
                case 7:
                    _d = _e.sent();
                    throw new Error("Failed to sign transaction");
                case 8:
                    lastTxId = "";
                    idx = 0;
                    _e.label = 9;
                case 9:
                    if (!(idx < fullySigned.length)) return [3 /*break*/, 12];
                    tx = fullySigned[idx];
                    return [4 /*yield*/, sendSignedTransaction({
                            connection: connection,
                            signedTransaction: tx,
                            blockhash: recentBlockhash,
                            lastValidBlockHeight: lastValidBlockHeight,
                        })];
                case 10:
                    result = _e.sent();
                    lastTxId = result.txid;
                    _e.label = 11;
                case 11:
                    ++idx;
                    return [3 /*break*/, 9];
                case 12:
                    setClaimSuccess(true);
                    setAlreadyClaimed(true);
                    setTxLink(explorerLinkFor(lastTxId, connection));
                    notify({
                        message: "Claim Successful!",
                        description: (_jsx(HyperLink, __assign({ href: explorerLinkFor(lastTxId, connection), target: "_blank", rel: "noopener" }, { children: "View transaction on explorer" }))),
                    });
                    return [3 /*break*/, 15];
                case 13:
                    err_3 = _e.sent();
                    console.error(err_3);
                    msg = "".concat((err_3 === null || err_3 === void 0 ? void 0 : err_3.message) || err_3);
                    if (msg.includes("ALREADY_CLAIMED")) {
                        setAlreadyClaimed(true);
                        notify({
                            message: "Already Claimed",
                            description: "You have already claimed your $CARDS airdrop.",
                        });
                    }
                    else if (/insufficient (lamports|funds)|debit an account but found no record|insufficient funds for rent/i.test(msg)) {
                        // Claimant pays the network fee + token-account rent. Embedded wallets
                        // (email/Google/Apple logins) start with 0 SOL, so this is the common
                        // failure — make it actionable instead of cryptic.
                        notify({
                            message: "Not enough SOL",
                            description: "This wallet needs a little SOL (about 0.003) to cover the network fee for the claim. Add some SOL to the wallet and try again.",
                        });
                    }
                    else {
                        notify({
                            message: "Claim Failed",
                            description: msg,
                        });
                    }
                    return [3 /*break*/, 15];
                case 14:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var handleConnectWallet = function () {
        setWalletModalVisible(true);
    };
    if (!connected) {
        return (_jsx(Box, __assign({ sx: styles.container }, { children: _jsxs(Box, __assign({ sx: styles.card }, { children: [_jsx(Typography, __assign({ sx: styles.title }, { children: "$CARDS Airdrop 5" })), _jsx(Typography, __assign({ sx: styles.subtitle }, { children: "Connect your wallet to check if you're eligible for the airdrop" })), _jsx("button", __assign({ style: styles.connectButton, onClick: handleConnectWallet, onMouseOver: function (e) {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                                "0 8px 24px rgba(56, 189, 248, 0.4)";
                        }, onMouseOut: function (e) {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "none";
                        } }, { children: "Connect Wallet to Check Airdrop" }))] })) })));
    }
    if (checkingEligibility || !program) {
        return (_jsx(Box, __assign({ sx: styles.container }, { children: _jsxs(Box, __assign({ sx: styles.card }, { children: [_jsx(Typography, __assign({ sx: styles.title }, { children: "Checking Eligibility..." })), _jsx(Box, __assign({ sx: { display: "flex", justifyContent: "center", mt: 3 } }, { children: _jsx(CircularProgress, { sx: { color: "#f97316" } }) }))] })) })));
    }
    if (!claimData) {
        return (_jsx(Box, __assign({ sx: styles.container }, { children: _jsxs(Box, __assign({ sx: styles.card }, { children: [_jsx(Typography, __assign({ sx: styles.title }, { children: "$CARDS Airdrop" })), _jsx(Box, __assign({ sx: styles.errorCard }, { children: _jsx(Typography, __assign({ sx: styles.errorText }, { children: "Sorry, this wallet is not eligible for the airdrop." })) })), _jsxs(Typography, __assign({ sx: __assign(__assign({}, styles.subtitle), { marginBottom: 0 }) }, { children: ["Connected: ", wallet === null || wallet === void 0 ? void 0 : wallet.publicKey.toString().slice(0, 4), "...", wallet === null || wallet === void 0 ? void 0 : wallet.publicKey.toString().slice(-4)] }))] })) })));
    }
    if (alreadyClaimed || claimSuccess) {
        return (_jsx(Box, __assign({ sx: styles.container }, { children: _jsxs(Box, __assign({ sx: styles.card }, { children: [_jsx(Typography, __assign({ sx: styles.title }, { children: "$CARDS Airdrop" })), _jsx(Box, __assign({ sx: styles.successCard }, { children: _jsx(Typography, __assign({ sx: styles.successText }, { children: claimSuccess
                                ? "🎉 Claim successful! Your $CARDS have been sent to your wallet."
                                : "You have already claimed your $CARDS airdrop." })) })), _jsxs(Box, __assign({ sx: styles.amountContainer }, { children: [_jsx(Typography, __assign({ sx: styles.amountLabel }, { children: "Amount Claimed" })), _jsxs(Box, __assign({ sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "baseline",
                                } }, { children: [_jsx(Typography, __assign({ sx: styles.amountValue }, { children: formatAmount(claimData.amount) })), _jsx(Typography, __assign({ sx: styles.tokenSymbol }, { children: "$CARDS" }))] }))] })), txLink && (_jsx(HyperLink, __assign({ href: txLink, target: "_blank", rel: "noopener", sx: { color: "#38bdf8", textDecoration: "underline" } }, { children: "View transaction on explorer \u2192" })))] })) })));
    }
    return (_jsx(Box, __assign({ sx: styles.container }, { children: _jsxs(Box, __assign({ sx: styles.card }, { children: [_jsx(Typography, __assign({ sx: styles.title }, { children: "\uD83C\uDF89 You're Eligible!" })), _jsx(Typography, __assign({ sx: styles.subtitle }, { children: "Claim your $CARDS airdrop below" })), _jsxs(Box, __assign({ sx: styles.amountContainer }, { children: [_jsx(Typography, __assign({ sx: styles.amountLabel }, { children: "Your Airdrop Amount" })), _jsxs(Box, __assign({ sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "baseline",
                            } }, { children: [_jsx(Typography, __assign({ sx: styles.amountValue }, { children: formatAmount(claimData.amount) })), _jsx(Typography, __assign({ sx: styles.tokenSymbol }, { children: "$CARDS" }))] }))] })), _jsx(Box, __assign({ sx: { mb: 3 } }, { children: _jsxs(Box, __assign({ sx: styles.infoRow }, { children: [_jsx(Typography, __assign({ sx: styles.infoLabel }, { children: "Wallet" })), _jsxs(Typography, __assign({ sx: styles.infoValue }, { children: [handle.slice(0, 6), "...", handle.slice(-4)] }))] })) })), _jsx("button", __assign({ style: __assign(__assign({}, styles.button), (loading ? styles.buttonDisabled : {})), onClick: handleClaim, disabled: loading, onMouseOver: function (e) {
                        if (!loading) {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                                "0 8px 24px rgba(249, 115, 22, 0.4)";
                        }
                    }, onMouseOut: function (e) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                    } }, { children: loading ? (_jsxs(Box, __assign({ sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                        } }, { children: [_jsx(CircularProgress, { size: 20, sx: { color: "#ffffff" } }), _jsx("span", { children: "Claiming..." })] }))) : ("Claim $CARDS") }))] })) })));
};
